module.exports = __webpack_public_path__ + "img/Comic02-1.8262dde0.png";